export const services = [
  {
    id: 1,
    name: 'Basic Wash + Interior',
    icon: 'ri-water-flash-line',
    priceFrom: 79,
    description: 'Hand wash, dry, vacuum, and interior wipe-down'
  },
  {
    id: 2,
    name: 'Premium Wash + Deep Interior',
    icon: 'ri-sparkling-2-line',
    priceFrom: 149,
    description: 'Complete wash with deep interior cleaning and conditioning'
  },
  {
    id: 3,
    name: 'Paint Correction Stage 1',
    icon: 'ri-brush-line',
    priceFrom: 399,
    description: 'Remove light swirls and scratches for enhanced shine'
  },
  {
    id: 4,
    name: 'Paint Correction Stage 2',
    icon: 'ri-contrast-drop-line',
    priceFrom: 699,
    description: 'Advanced correction for deeper imperfections'
  },
  {
    id: 5,
    name: 'Ceramic Coating 1 Year',
    icon: 'ri-shield-star-line',
    priceFrom: 599,
    description: 'Professional grade ceramic protection for 1 year'
  },
  {
    id: 6,
    name: 'Ceramic Coating 3 Year',
    icon: 'ri-shield-check-line',
    priceFrom: 999,
    description: 'Premium ceramic coating with 3-year durability'
  },
  {
    id: 7,
    name: 'Ceramic Coating 5 Year',
    icon: 'ri-shield-flash-line',
    priceFrom: 1499,
    description: 'Ultimate ceramic protection lasting 5 years'
  },
  {
    id: 8,
    name: 'Deep Vacuum Restoration',
    icon: 'ri-refresh-line',
    priceFrom: 199,
    description: 'Intensive vacuum and restoration for heavily soiled interiors'
  },
  {
    id: 9,
    name: 'Engine Bay Detailing',
    icon: 'ri-settings-3-line',
    priceFrom: 149,
    description: 'Complete engine compartment cleaning and dressing'
  },
  {
    id: 10,
    name: 'Headlight Restoration',
    icon: 'ri-lightbulb-flash-line',
    priceFrom: 99,
    description: 'Restore clarity and brightness to oxidized headlights'
  },
  {
    id: 11,
    name: 'Leather Conditioning',
    icon: 'ri-t-shirt-line',
    priceFrom: 129,
    description: 'Deep conditioning and protection for leather surfaces'
  },
  {
    id: 12,
    name: 'Pet Hair Removal',
    icon: 'ri-bear-smile-line',
    priceFrom: 89,
    description: 'Specialized removal of stubborn pet hair from all surfaces'
  },
  {
    id: 13,
    name: 'Odor Elimination',
    icon: 'ri-mist-line',
    priceFrom: 119,
    description: 'Ozone treatment to eliminate persistent odors'
  },
  {
    id: 14,
    name: 'Scratch Removal',
    icon: 'ri-eraser-line',
    priceFrom: 179,
    description: 'Professional scratch and scuff removal service'
  },
  {
    id: 15,
    name: 'Chrome Polishing',
    icon: 'ri-contrast-2-line',
    priceFrom: 79,
    description: 'Restore shine to chrome trim and accents'
  },
  {
    id: 16,
    name: 'Wheel & Tire Detailing',
    icon: 'ri-steering-2-line',
    priceFrom: 99,
    description: 'Deep cleaning and protection for wheels and tires'
  },
  {
    id: 17,
    name: 'Convertible Top Treatment',
    icon: 'ri-sun-line',
    priceFrom: 149,
    description: 'Specialized cleaning and protection for convertible tops'
  },
  {
    id: 18,
    name: 'Paint Protection Film',
    icon: 'ri-file-shield-line',
    priceFrom: 1299,
    description: 'Clear protective film against rock chips and scratches'
  },
  {
    id: 19,
    name: 'Interior Sanitization',
    icon: 'ri-heart-pulse-line',
    priceFrom: 129,
    description: 'Anti-microbial treatment for a germ-free cabin'
  },
  {
    id: 20,
    name: 'Showroom Finish Package',
    icon: 'ri-vip-crown-line',
    priceFrom: 899,
    description: 'Complete detailing for showroom-quality results'
  }
];